import { render, staticRenderFns } from "./qk_head.vue?vue&type=template&id=1379c470&scoped=true"
import script from "./qk_head.vue?vue&type=script&lang=js"
export * from "./qk_head.vue?vue&type=script&lang=js"
import style0 from "./qk_head.vue?vue&type=style&index=0&id=1379c470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1379c470",
  null
  
)

export default component.exports